var exports = {
  "text": "x24da60e8--afded7--text",
  "level-1": "x24da60e8--afded7--level-1",
  "level-2": "x24da60e8--afded7--level-2",
  "level-3": "x24da60e8--afded7--level-3",
  "level-4": "x24da60e8--afded7--level-4",
  "level-5": "x24da60e8--afded7--level-5",
  "level-6": "x24da60e8--afded7--level-6",
  "normal": "x24da60e8--afded7--normal",
  "bold": "x24da60e8--afded7--bold",
  "primary": "x24da60e8--afded7--primary",
  "secondary": "x24da60e8--afded7--secondary",
  "error": "x24da60e8--afded7--error",
  "link": "x24da60e8--afded7--link",
  "current-color": "x24da60e8--afded7--current-color",
};

module.exports = exports;
